import React from 'react'
import { Modal, Backdrop, Fade, Button } from '@material-ui/core'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import { makeStyles } from '@material-ui/core/styles'
import './wizardPopup.css'

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1300,
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: '8px',
        boxShadow: theme.shadows[5],
        padding: 0,
        width: '90%',
        maxWidth: '800px',
        maxHeight: '90vh',
        overflowY: 'auto',
    },
}))

const WizardTermsPopup = ({ open, handleClose, onAccept, product }) => {
    const classes = useStyles()

    const RemovalDate = ({ apiDate }) => {
        const date = new Date(apiDate)
        date.setDate(date.getDate() + 10)
        return (
            <strong>
                <span>
                    {date.toLocaleDateString('en-US', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                    })}
                </span>
            </strong>
        )
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            className={classes.modal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 300 }}
        >
            <Fade in={open}>
                <div className={`wizard-popup ${classes.paper}`}>
                    <div className="modal-header">
                        <h4 className="modal-title">Auction Terms and Conditions</h4>
                        <Button className="close" onClick={handleClose}>
                            <span className="material-icons">close</span>
                        </Button>
                    </div>
                    <div className="modal-body cm-body">
                        {product?.auction_state?.toLowerCase().includes('california') && (
                            <div className="prop65-warning">
                                <strong>⚠ WARNING:</strong> Products sold through{' '}
                                <strong>Wiz.Bid</strong> may expose you to chemicals that are known
                                to the State of California to cause cancer and birth defects or
                                other reproductive harm.
                            </div>
                        )}
                        <table className="termsTable">
                            <tbody>
                                <tr>
                                    <td className="termsTableThree">
                                        <strong>Location:</strong> Address
                                        <br />
                                        <strong>Hours of operation:</strong>
                                    </td>
                                    <td className="termsTableTwo">
                                        <p>
                                            ALL items in this auction{' '}
                                            <strong>start at $1 with no reserve.</strong>
                                        </p>
                                        <p>
                                            <strong>Item Conditions:</strong> Items are listed as{' '}
                                            <strong>
                                                Like New, Open Box, Damaged, or For Parts.
                                            </strong>
                                        </p>
                                        <p>
                                            Please refer to the [Terms and Conditions] for complete
                                            condition definitions. We do not test all items for full
                                            functionality. “Open Box” items may be{' '}
                                            <strong>
                                                new, used, incomplete, damaged, or mislabeled
                                            </strong>
                                            .
                                        </p>

                                        <p>
                                            We rely on manufacturer descriptions and do our best to
                                            describe each item accurately, but{' '}
                                            <strong>
                                                we cannot guarantee 100% accuracy. We strongly
                                                recommend that all bidders personally inspect items
                                                prior to placing bids.
                                            </strong>
                                        </p>

                                        <p>
                                            <strong>
                                                All items are sold AS-IS. No returns or refunds will
                                                be accepted for any reason.
                                            </strong>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="termsTableTwo">
                                        <strong>Location:</strong>
                                        <br />
                                        <strong>Date & Time:</strong>
                                        <br />
                                        <strong>Payment:</strong>
                                        <br />
                                        <strong>Removal:</strong>
                                        <br />
                                        <strong>Fees:</strong>
                                    </td>
                                    <td className="termsTableTwo">
                                        <p>
                                            <strong>Location:</strong> {product?.auction_address},{' '}
                                            {product?.auction_state}, {product?.auction_country}
                                        </p>
                                        <p>
                                            <strong>Date & Time:</strong>{' '}
                                            {new Date(product?.date_closed).toDateString()}
                                        </p>
                                        <p>
                                            <strong>Payment:</strong> The credit card on file will
                                            be automatically charged upon auction close. No cash or
                                            alternative payments will be accepted.
                                        </p>
                                        <p>
                                            <strong>Removal:</strong> Please bring your{' '}
                                            <strong>emailed receipt</strong> to pick up items during{' '}
                                            <strong>posted pickup hours.</strong>
                                            <br />
                                            Items must be picked up no later than{' '}
                                            <RemovalDate apiDate={product?.date_closed} />
                                            .
                                            <br /> Items not removed by the deadline will be
                                            <strong> considered abandoned,</strong> and{' '}
                                            <strong>no refunds</strong> will be issued.
                                        </p>

                                        <p>
                                            <strong>Fees:</strong> A{' '}
                                            <strong>13% Buyer&apos;s Premium </strong> will be
                                            added.
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="terms" style={{ textAlign: 'center', marginTop: 24 }}>
                            <PrimaryButton label="Accept" onClick={onAccept} />
                        </div>
                    </div>
                </div>
            </Fade>
        </Modal>
    )
}

export default WizardTermsPopup
